module.exports = __webpack_public_path__ + "img/base_activites_livre.1eddf247.svg";